import {styled} from "@mui/material/styles"
import {css} from "@emotion/react"
import Grid from "@mui/material/Grid"
import {Box, type BoxProps, type GridProps} from "@mui/material"
import {Typography} from "@mui/material"
import {AppNewThemeProvider} from "@indebted/theme/AppTheme"
import {paletteColors} from "@indebted/theme"
import {ReactNode} from "react"

const Page = styled(({padded, ...props}: {padded?: boolean} & GridProps) => (
	<Grid container direction="column" alignItems="center" spacing={5} {...props} />
))`
	flex 1;
	padding: 0;
	padding-top: ${(props) => props.theme.spacing(5)};
	padding-bottom: ${(props) => props.theme.spacing(5)};

	${(props) =>
		props.padded &&
		`
		padding-left: ${props.theme.spacing(5)};
		padding-right: ${props.theme.spacing(5)};
	`}
`

export const PageTitle = styled(Typography)`
	font-size: 2rem;
	font-weight: 700;
	color: #000244;
	margin-bottom: 1rem;
`

export const PageSubtitle = styled(Typography)`
	font-size: 0.9375rem;
	font-weight: 400;
	color: #4d4e7c;
`

export const HorizontalContentPadding = css`
	/* <359px: Minimal padding for very small screens */
	padding-left: 1rem;
	padding-right: 1rem;

	/* 360px to 410px: Small mobile padding */
	@media (min-width: 360px) {
		padding-left: 1.5rem;
		padding-right: 1.5rem;
	}

	/* 411px to 599px: Large mobile padding */
	@media (min-width: 411px) {
		padding-left: 2rem;
		padding-right: 2rem;
	}

	/* 600px to 899px: Tablet padding */
	@media (min-width: 600px) {
		padding-left: 5rem;
		padding-right: 5rem;
	}

	/* >900px: Desktop padding */
	@media (min-width: 900px) {
		padding-left: 7.5rem;
		padding-right: 7.5rem;
	}
`

export const NewLayoutPage = styled(({children, ...props}: {children: ReactNode} & BoxProps) => {
	return (
		<Box {...props}>
			<AppNewThemeProvider>{children}</AppNewThemeProvider>
		</Box>
	)
})`
	background-color: ${paletteColors.pageBackground};
	font-family: "Manrope", sans-serif;
	margin: 0 auto;
	flex: 1;
	min-height: 100vh;

	/* Responsive top/bottom padding */
	/* <359px: Minimal padding for very small screens */
	padding-top: 1.5rem;
	padding-bottom: 1.5rem;

	/* 360px to 410px: Small mobile padding */
	@media (min-width: 360px) {
		padding-top: 1.5rem;
		padding-bottom: 1.5rem;
	}

	/* 411px to 599px: Large mobile padding */
	@media (min-width: 411px) {
		padding-top: 2rem;
		padding-bottom: 2rem;
	}

	/* 600px to 899px: Tablet padding */
	@media (min-width: 600px) {
		padding-top: 2.5rem;
		padding-bottom: 2.5rem;
	}

	/* >900px: Desktop padding */
	@media (min-width: 900px) {
		padding-top: 2.5rem;
		padding-bottom: 2.5rem;
	}

	${HorizontalContentPadding}
`

export {Page}
